let mapsLoadPromise: Promise<void> | null = null;

export function isGoogleMapsLoaded(): boolean {
  return typeof window !== "undefined" && !!window.google?.maps;
}

export function getGoogleMapsScriptUrl(apiKey: string): string {
  return `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=maps,places`;
}

export function shouldInjectGoogleMapsScript(): boolean {
  if (isGoogleMapsLoaded()) return false;
  if (typeof document === "undefined") return true;
  return !document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
}

export async function loadGoogleMaps(): Promise<void> {
  if (typeof window === "undefined") {
    throw new Error("Google Maps loader can only be used in browser");
  }

  if (isGoogleMapsLoaded()) {
    return Promise.resolve();
  }

  if (mapsLoadPromise) {
    return mapsLoadPromise;
  }

  mapsLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&libraries=maps,places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = () => {
      mapsLoadPromise = null;
      reject(new Error("Failed to load Google Maps"));
    };

    document.head.appendChild(script);
  });

  return mapsLoadPromise;
}
